<app-confirmation-modal
  [title]="'Event ending soon' | translate"
  [description]="localizedDialogDescription$ | async"
  [confirmButtonConfig]="{
    icon: isEndEventHovered ? 'checkered-flag-red' : 'checkered-flag',
    iconType: 'svg-icon',
    label: 'End event now' | translate,
    danger: true
  }"
  [ngClass]="{ isXsmall: isXsmallScreen$ | async }"
  [hasCloseButton]="true"
  (confirmButtonHovered)="$event ? (isEndEventHovered = true) : (isEndEventHovered = false)"
  (confirmButtonClicked)="handleEndEvent()"
  (closeButtonClicked)="close()"
>
  <div *ngIf="extendEventEnabled" class="extend-button-wrapper" custom-cancel-button>
    <app-pencil-button
      [theme]="'secondary-outline'"
      [label]="extensionTimeOptions.get(Array.from(extensionTimeOptions.keys()).pop() || 0)"
      [icon]="'alarm_add'"
      [iconConfig]="{ type: 'material-icon' }"
      class="extend-button"
      (click)="extendEvent(Array.from(extensionTimeOptions.keys()).pop() || 0)"
    ></app-pencil-button>
    <app-pencil-button
      [theme]="'secondary-outline'"
      [icon]="'keyboard_arrow_down'"
      [iconConfig]="{ type: 'material-icon' }"
      [matMenuTriggerFor]="extendMenu"
      class="extend-button-dropdown"
    ></app-pencil-button>
    <mat-menu #extendMenu="matMenu" class="extend-menu">
      <button
        *ngFor="let minutes of Array.from(extensionTimeOptions.keys())"
        mat-menu-item
        (click)="extendEvent(minutes)"
      >
        <span>{{ extensionTimeOptions.get(minutes) || '' }}</span>
      </button>
    </mat-menu>
  </div>
</app-confirmation-modal>
